export function onlyDigits(key: string, withCtrl = false) {
  const specButtons = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
    "Home",
    "End",
  ];
  const isDigit = /[0-9]/.test(key);
  const isSpecial = specButtons.includes(key);
  const isCtrlCombination =
    withCtrl && ["a", "c", "v", "x"].includes(key.toLowerCase());

  return !(!isDigit && !isSpecial && !isCtrlCombination);
}
